import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { secureBusinessKey, apiEndpoints } from "../api/apiEndpoints";
import Cookies from "js-cookie";
import { Bounce, toast } from "react-toastify";
export const getOrderDoneData = createAsyncThunk(
  "order/getOrderDoneData",
  async (_, { rejectWithValue }) => {
    try {
      const cartItems = JSON.parse(sessionStorage.getItem("cartItems")) || {};
      // console.log("cartItems", cartItems);

      const filteredCartItemsServices = {};
      const isService = cartItems.is_service || [];

      Object.keys(cartItems).forEach((key) => {
        if (Array.isArray(cartItems[key])) {
          filteredCartItemsServices[key] = cartItems[key].filter(
            (_, index) => isService[index] === true
          );
        }
      });

      const duration = filteredCartItemsServices.product?.map(
        (prod) => prod?.unit?.value
      );

      const servicesIdArray = filteredCartItemsServices.product_id || [];
      const servicesQtyArray = filteredCartItemsServices.product_qty || [];
      const servicesPriceArray = filteredCartItemsServices.product_price || [];
      const employeesIdArray = filteredCartItemsServices.professionals_id || [];

      const todayDate = new Date().toISOString().split("T")[0];
      const customerId = Cookies.get("customer_id");
      const branchId = Cookies.get("brunch_id");
      const orderID = sessionStorage.getItem("order_id");

      const startTime = new Date();
      const formatTime = (date) =>
        `${date.getHours().toString().padStart(2, "0")}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")}`;

      const startTimeArray = Array(duration.length).fill(formatTime(startTime));
      const endTimeArray = duration.map((dur) => {
        const endTime = new Date(startTime.getTime() + dur * 60 * 1000);
        return formatTime(endTime);
      });
      const sessionExpired = (msg) => {
        toast(msg, {
          style: {
            background: "#f87171",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "2rem",
            padding: "1rem",
            width: "20dvh",
          },
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
          transition: Bounce,
          closeButton: ({ closeToast }) => (
            <button
              className="text-white text-4xl leading-none rounded-full p-2"
              onClick={closeToast}
            >
              ×
            </button>
          ),
        });
      };
      const personal_token = Cookies.get("personal_token");

      if (!personal_token) {
        sessionExpired("Session has expired");
        setTimeout(() => {
          window.location.href = "/logout";
        }, 3000);
        return Promise.reject(
          new Error("Personal Token is missing. Redirecting to logout.")
        );
      }
      const options = {
        url: apiEndpoints.orderReservation.url,
        method: "POST",
        headers: {
          "Accept-Language": "en",
          "secure-business-key": secureBusinessKey,
          "user-token": personal_token,
        },
        data: {
          title: `new reservation on ${todayDate}`,
          customer_id: customerId,
          start_date: todayDate,
          end_date: todayDate,
          start_time: startTimeArray,
          end_time: endTimeArray,
          service_id: servicesIdArray,
          service_price: servicesPriceArray,
          service_qty: servicesQtyArray,
          employee_id: employeesIdArray,
          color: "#000",
          background_color: "#uuuu",
          branch_id: branchId,
          check_conflicts: false,
          // ecomm_order_id: orderID,
        },
      };

      const { data } = await axios.request(options);
      console.log("Order Data:", data);

      return {
        reservationData: data,
        parentReservationId: data?.data?.id,
        reservationIds: data?.data?.items?.map((item) => item?.id),
        serviceIds: data?.data?.items?.map((item) => item?.service_id),
        orderID,
      };
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const orderSlice = createSlice({
  name: "order",
  initialState: {
    orderDone: null,
    isLoading: false,
    isError: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrderDoneData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrderDoneData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orderDone = action.payload.reservationData;
      })
      .addCase(getOrderDoneData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload || action.error.message;
        state.orderDone = action.payload.reservationData;
      });
  },
});

export const orderReducer = orderSlice.reducer;
//  url: "https://testecommerce.vodoglobal.com/api/v2/update_reservation_id/"
